<template>
  <div class="box-header"
  @mousedown="$emit('click')"
  :class="{
    'selected': selected
  }"
  >
    <div class="box-header--name">
      {{$dft.capitalizeWords($t(name))}}
    </div>
    <div class="box-header--body">
      <slot name="body"></slot>
    </div>
    <div class="box-header--options">
      
      <!-- <v-icon
      v-if="isPinnable"
      class="pin"
      @click="$emit('pin')"
      >fas fa-thumbtack</v-icon> -->

      <!-- <faicon
      v-if="isPinnable"
      class="faicon pin"
      @click="$emit('pin')"
      icon="thumbtack"
      ></faicon> -->

      <!-- TOD: Later implement the pinning perfectly. The Pin Button. Commented For now. -->

      <!-- <img 
        src="static/icons/pin.svg" 
        class="dt-icon v4" 
        alt="Pin Box"
        title="Pin Box" 
        v-if="isPinnable"
        @click="$emit('pin')"
      > -->
      
      <!-- <svg width="30px" height="30px" class="dt-svg" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icon/pin</title>
        <desc>Created with Sketch.</desc>
        <g id="Icon/pin" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group" transform="translate(11.500000, 8.500000)" stroke="#828282">
              <circle id="Oval" cx="4" cy="4" r="4"></circle>
              <path d="M4,8.25 L4,13" id="Line" stroke-linecap="round"></path>
          </g>
        </g>
      </svg> -->


      <!-- <v-icon
      v-if="!minimized"
      class="minimize"
      @click="$emit('minimize')"
      >minimize</v-icon> -->

      <!-- The Minimize Icon. Commented For now -->

      <!-- <img 
        src="static/icons/minus-accent.svg" 
        class="dt-icon v4" 
        alt="Minimize Box"
        title="Minimize Box"
        v-if="!minimized"
        @click="$emit('minimize')"
      > -->

      <!-- <v-icon
      v-if="minimized"
      class="maximize"
      @click="$emit('maximize')"
      >add</v-icon> -->

      <img 
        src="static/icons/plus-accent.svg" 
        class="dt-icon v4" 
        alt="Maximize Box"
        title="Maximize Box"
        v-if="minimized"
        @click="$emit('maximize')"
      >

    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String
    },
    selected: {
      type: Boolean
    },
    minimized: {
      type: Boolean
    },
    isPinnable: {
      type: Boolean
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">

  .box-header {
    color: var(--text-accent);
    // background: white;
    z-index: 0;

    cursor: default;
    transition: 150ms ease-out;

    margin: -1px -1px 0px -1px;

    border-top: 1px solid   transparent;
    border-left: 1px solid  transparent;
    border-right: 1px solid transparent;
    border-bottom: 1px solid var(--text-accent);

    display: flex;

    justify-content: space-between;

    &--name {
      padding: 5px 10px;
    }

    .box-header--row {
      padding: 5px 10px;
    }

    &--body {
      flex:1;
    }

    &--options {

      display: flex;  

      svg {
        border-left: 1px solid var(--text-accent);
      }

      img {
        border-left: 1px solid var(--text-accent);
        width: 30px;
      }
    }

    &.selected {
      background-color: var(--bc-selected);
      border-top: 1px solid var(--text-accent);
      border-left: 1px solid var(--text-accent);
      border-right: 1px solid var(--text-accent);
    }

    &.gray {
      background-color: var(--sprt-75);
      border-top: 1px solid var(--sprt-75);
      border-bottom: 1px solid var(--sprt-75);
      border-left: 1px solid var(--sprt-75);
      border-right: 1px solid var(--sprt-75);
      color: white;
    }



    // .box-header--options {
    // }

    i.fas {
      font-size: 14px;
    }
  }



</style>
